var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar-content",class:{ 'nav-bar-opacity1': _vm.opacity == 1 },style:({
    height: _vm.height + 'px',
    paddingTop: _vm.statusBarHeight + 'px',
    backgroundColor: 'rgba(255,255,255,' + _vm.opacity + ')'
  })},[_c('div',{staticClass:"back",on:{"click":_vm.bindBack}},[_c('i',{staticClass:"iconfont icon-you"})]),_c('div',{staticClass:"title",style:({
      opacity: _vm.opacity
    })},[_vm._v(_vm._s(_vm.opacity >= 0.2 ? _vm.detailData.name : ''))]),(_vm.showShare)?_c('div',{staticClass:"share",on:{"click":_vm.bindShare}},[_c('i',{staticClass:"iconfont icon-fenxiang11"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }